import Vue from 'vue'
import LazyComponent from 'v-lazy-component/vue2'

Vue.use(LazyComponent)
